export default "__VITE_ASSET__7FOejEyA__"